<template>
  <transition name="fade-fast">
    <div v-if="show" class="popup" :style="computedStyle">
      <div class="popup__container">
        <div v-if="has_header" class="popup__header">
          <slot name="header"></slot>
        </div>
        <div v-if="has_content" class="popup__content">
          <slot name="content"></slot>
        </div>
        <div v-if="has_footer" class="popup__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    computedStyle() {
      return this.position
        ? { top: this.position.top, left: this.position.left }
        : {};
    },
    has_header() {
      return !!this.$slots.header;
    },
    has_content() {
      return !!this.$slots.content;
    },
    has_footer() {
      return !!this.$slots.footer;
    },
  },
  methods: {
    close() {
      this.$emit("close", false);
    },
  },
};
</script>

<style scoped src="@/assets/css/components/popup.css"></style>
